<template>

	<v-card class="elevation-0">

		<v-card-title>
			<div v-if="!parent_selected">
				{{ trans('ticket.'+category) }}
			</div>
			<div v-if="parent_selected">
				{{ options[parent_selected].title }}
			</div>
		</v-card-title>

		<v-card-text>
			<div class="text-center py-5 my-5" v-if="loading">
				<v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
			</div>

			<v-list class="px-0" nav dense v-if="options && !parent_selected">
				<v-list-item-group v-model="option_p" color="primary">
				    <v-list-item v-for="(option,id,index) in options" :key="index" @click="goToChild(option.id)">
						<v-list-item-content>
							<v-list-item-title>{{ option.title }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
	 
			<v-list class="px-0" nav dense v-if="child_options && !sent">
				<v-list-item-group v-model="option_n" color="primary">
					<v-list-item v-for="(option,id,index) in child_options" :key="index" @click="confirmComplain(option.id)">
						<v-list-item-content>
							<v-list-item-title>{{ option.title }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list> 

			<v-list class="px-0" v-if="sent">
				<v-list-item>
					<v-list-item-avatar :color="(errors ? 'secondary' : 'primary')">
						<v-icon dark>{{ errors ? 'mdi-times' : 'mdi-check' }}</v-icon>
					</v-list-item-avatar>
					<v-list-item-content>
						{{ errors ? trans('ticket.report_failed') : trans('ticket.report_success') }}
					</v-list-item-content>
				</v-list-item>
			</v-list> 
			
		</v-card-text>

		<v-card-actions>
			<v-btn v-if="parent_selected" @click="goToRoot" text>{{ trans('app.back') }}</v-btn>
			<v-btn v-if="!parent_selected" @click="cancelComplain" text>{{ trans('app.cancel') }}</v-btn>
			<v-spacer></v-spacer>
			<v-btn v-if="selected" @click="sendComplain" :disabled="sent" :loading="sending" color="primary" depressed>{{ trans('app.submit') }}</v-btn>
		</v-card-actions>
	</v-card>

</template>

<script>
	import _ from 'lodash';
	import api from '../../api';

    export default {

        props: [
            'subject_uuid'
        ],

        data: function()
        {
            return {
                category: 'report.property',
                loading: true,
                sending: false,
                options: null,
                parent_selected: null,
                selected: null,
                sent: false,
                errors: false,
                // doesn't matter
                option_p: null,
                option_n: null,
            }
        },

        computed: {
        	child_options: function() {
        		return _.get(this.options, this.parent_selected+'.children', null);
        	}
        },

    	mounted: function()
    	{
    		this.loadOptions();
    	},


    	methods: {

    		loadOptions: function()
    		{
    			this.loading = true;
	    		api.ticket
	    			.create({category: this.category})
	    			.then((result) => {
		                this.options = result.data.options;
                        this.loading = false;
		            })
		            .catch((error) => {
		                this.loading = false;
		            });
    		},

            goToChild: function(category_id)
            {
                this.parent_selected = category_id.replace(/\./g, '_');
                this.selected = null;
                this.option_n = null;
            },

            goToRoot: function()
            {
                this.parent_selected = null;
                this.selected = null;
                this.option_p = null;
                this.option_n = null;
            },

            confirmComplain: function(category_id)
            {
                this.selected = category_id;
            },

            cancelComplain: function()
            {
            	this.parent_selected = null;
                this.selected = null;
                this.option_p = null;
                this.option_n = null;

                if (this.sending) return;

                this.$emit('cancel');
            },

            sendComplain: function()
            {
                if (this.sending) return;

                this.sending = true;
                api.ticket
	                .store({
	                    category: this.selected,
	                    subject_uuid: this.$props.subject_uuid,
	                    subject_type: 'property' // can be hardcoded now.
	                })
	                .then((result) => {
	                    this.showSuccessMessage();
	                })
	                .catch((error) => {
	                    this.errors = true;
	                    this.showErrorMessage();
	                });
            },

            showSuccessMessage: function()
            {
                this.sent = true;
                this.sending = false;
                setTimeout(() => {
                    this.$emit('cancel');
                }, 3000);
            },

            showErrorMessage: function()
            {
                this.sent = true;
                this.sending = false;
                setTimeout(() => {
                    this.$emit('cancel');
                    this.sent = false;
                }, 3000);
            },

    	}

    }
</script>